'use client'
import { useEffect, useState, useRef } from 'react';

const IPhone = ({ screenComponent: ScreenComponent }) => {
  const [isCharging, setIsCharging] = useState(false);
  const hasCharged = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const scrollThreshold = windowHeight * 0.3;

      if (scrollPosition > scrollThreshold && !hasCharged.current) {
        setIsCharging(true);
        hasCharged.current = true;  // Mark as charged
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      <div className="z-20">
        <div className="z-[-1] scale-[2.0] m-5 border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[600px] w-[300px] max-w-[75vw] shadow-xl">
          <div className="w-[128px] h-[26px] bg-gray-950 top-0 rounded-b-[1rem] left-[132px] -translate-x-1/2 absolute"></div>
          <div className="h-[46px] w-[3px] bg-gray-800 absolute -start-[17px] top-[124px] rounded-s-lg"></div>
          <div className="h-[46px] w-[3px] bg-gray-800 absolute -start-[17px] top-[178px] rounded-s-lg"></div>
          <div className="h-[64px] w-[3px] bg-gray-800 absolute -end-[17px] top-[142px] rounded-e-lg"></div>
          <div className="rounded-[2rem] overflow-hidden w-[272px] h-[572px] bg-white dark:bg-gray-800">
            <video
              className="dark:hidden w-[272px] h-[572px] object-cover"
              autoPlay
              muted
              playsInline
              loop
              preload="auto"
              onError={(e) => {
                console.error('Video loading error:', e);
              }}
            >
              <source src="/demo_videos/demo1.mov" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <video
              className="hidden dark:block w-[272px] h-[572px] object-cover"
              autoPlay
              muted
              playsInline
              loop
              preload="auto"
              onError={(e) => {
                console.error('Video loading error:', e);
              }}
            >
              <source src="/demo_videos/demo1.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
      <div className={`absolute bottom-0 left-1/2 -translate-x-1/2 w-16 z-[-1] ${
        isCharging ? 'animate-charge' : hasCharged.current ? 'translate-y-[169%] opacity-1' : 'translate-y-full opacity-0'
      }`}>
        <div className="relative w-16 h-28 bg-gray-400 rounded-b-lg">
          <div className="absolute top-2 left-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-gray-300/20">
            <div className={`w-2 h-2 rounded-full bg-gray-400 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${
              isCharging ? 'animate-glow' : hasCharged.current ? 'bg-green-500 shadow-lg shadow-green-500/50' : ''
            }`} />
          </div>
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-gray-400 rounded-t-lg" />
        </div>
        <div className="w-8 h-80 mx-auto bg-gradient-to-b from-gray-400 to-transparent" />
      </div>
    </div>
  );
};

export default IPhone;